import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Icons from '../../../../../../components/Common/Icons/Icons';
import FakePagination from '../../../../../../components/Common/UI/FakePagination';
import type { ITemplate } from '../../../../../notifications';
import { formatTime } from '../../../../../notifications';

dayjs.extend(customParseFormat);

interface IProps {
  email: ITemplate;
}

function EmailHead({ email }: IProps) {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex items-center px-[20px] py-[10px] justify-between border-b border-[#f7f8fc]">
        <div className="flex items-center gap-[20px]">
          <Icons.BoldArrow className="cursor-pointer" onClick={() => navigate('/guidance/notifications')} />
          <img src="/guidance/email/actions.png" alt="actions" className="h-[34px]" />
          <Icons.More className="cursor-pointer rotate-90" />
        </div>
        <div className="flex items-center gap-[30px]">
          <FakePagination value="1-4 of 4" />
          <div className="flex items-center text-addition11 cursor-pointer">
            <div className="opacity-60">En</div>
            <Icons.ArrowRight className="rotate-90 opacity-50" />
          </div>
        </div>
      </div>
      <div className="pl-[60px] py-[10px] pr-[20px] border-b border-[#f7f8fc] flex justify-between items-start">
        <div>
          <div className="text-[24px] mb-[10px]">{email.subject}</div>
        </div>
        <img src="/guidance/email/actions2.png" alt="actions2" className="h-[17px]" />
      </div>
      <div className="py-[10px] px-[20px] border-b border-[#f7f8fc]">
        <div className="flex items-start gap-[10px]">
          <img src="/guidance/avatar.png" alt="avatar" className="h-[44px]" />
          <div className="w-full">
            <div className="flex items-center gap-[10px] justify-between">
              <div className="flex items-center gap-[10px] leading-[20px] text-[18px] font-bold">
                {email.author ?? 'Guidance Financial Institution'}
                <div className="text-addition11-50 font-normal">{'<alerts@guidance.com>'}</div>
              </div>
              <div className="flex items-center gap-[10px]">
                <div className="text-[16px] font-medium">{`${formatTime(email.time)}`}</div>
                <Icons.Star className="[&_path]:fill-addition11-30" />
                <img src="/guidance/email/actions3.png" alt="actions" className="h-[19px]" />
              </div>
            </div>
            <div className="flex items-center cursor-pointer text-[18px] leading-[20px]">
              <div className="opacity-50">to me</div>
              <Icons.ArrowRight className="rotate-90" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmailHead;
